<script>

    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let zones = []
    export let selectedId = null
    export let loading = false

</script>

<style>
    .zone-list {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .zone-list__item {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 10px;
        border: 0;
        border-radius: 12px;
        background: transparent;
        text-align: left;
        cursor: pointer;
    }

    .zone-list__item:hover,
    .zone-list__item.is-selected {
        background: #f4f4f4;
    }

    .zone-list__color {
        flex: none;
        width: 14px;
        height: 14px;
        border-radius: 50%;
    }

    .zone-list__text {
        min-width: 0;
    }

    .zone-list__name {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
    }

    .zone-list__driver {
        display: block;
        font-size: 12px;
        color: #6b6b6b;
        overflow-wrap: anywhere;
    }

    .zone-list__empty {
        margin: 0;
        padding: 10px;
        font-size: 13px;
        color: #6b6b6b;
    }
</style>

{#if zones.length}
    <ul class="zone-list">
        {#each zones as zone (zone._id)}
            <li>
                <button
                    type="button"
                    class="zone-list__item"
                    class:is-selected={String(zone._id) === String(selectedId)}
                    on:click={() => dispatch('select', zone)}
                >
                    <span class="zone-list__color" style="background: {zone.color}"></span>
                    <span class="zone-list__text">
                        <span class="zone-list__name">{zone.code} · {zone.name}</span>
                        <span class="zone-list__driver">{zone.driver ? zone.driver.name : 'Sin driver'}</span>
                    </span>
                </button>
            </li>
        {/each}
    </ul>
{:else if !loading}
    <p class="zone-list__empty">Aún no hay zonas. Crea la primera con "Nueva zona".</p>
{/if}
